import React, { useEffect, useState } from 'react';
import { STAGE_V2 } from '../constants/stage';
import { IKeyValMap } from '../interfaces/IKeyValMap';
import MetadataService from '../metadata.service';
import { Tag } from './Tag';

// TODO: check color configuration for new stages
export const ApplicationStageV2 = ({ stage }: { stage: string }) => {
  const [applicationStages, setApplicationStages] = useState({} as IKeyValMap);

  useEffect(() => {
    let mounted = true;
    MetadataService.getApplicationStages().then(data => {
      if (mounted) {
        setApplicationStages(data);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  let color;
  switch (stage) {
    // v1 stages
    case STAGE_V2.INITIAL_REVIEW:
      color = 'Teal';
      break;
    case STAGE_V2.READY_FOR_REVIEW:
      color = 'LightBlue';
      break;
    case STAGE_V2.WAITING_FOR_EVIDENCE:
      color = 'DarkGray';
      break;
    case STAGE_V2.READY_FOR_DECISION:
      color = 'Indigo';
      break;
    case STAGE_V2.FINAL_TASKS:
      color = 'Orange';
      break;
    case STAGE_V2.COMPLETED:
      color = 'Green';
      break;
    case STAGE_V2.POST_ISSUE_AUDIT:
      color = 'Yellow';
      break;
    case STAGE_V2.AUDIT:
      color = 'NoraPink';
      break;
    case STAGE_V2.AUDIT_COMPLETED:
      color = 'Maroon';
      break;

    // New stages
    case STAGE_V2.APPROVED:
      color = 'MediumSeaGreen';
      break;
    case STAGE_V2.DECLINED:
      color = 'Red';
      break;
    case STAGE_V2.INELIGIBLE:
      color = 'DarkScarlet';
      break;
    case STAGE_V2.WITHDRAWN:
      color = 'Gray';
      break;
    case STAGE_V2.WAIVED:
      color = 'FeGreen';
      break;
    case STAGE_V2.RESCINDED:
      color = 'Coral';
      break;
    case STAGE_V2.EVIDENCE_ON_HOLD:
      color = 'OliveDrab';
      break;
    case STAGE_V2.PIA_SKIPPED:
      color = 'LightOrange';
      break;
    case STAGE_V2.PEER_REVIEW:
      color = 'DodgerBlue';
      break;
    case STAGE_V2.FRAUD_INVESTIGATION:
      color = 'Brown';
      break;
    case STAGE_V2.CARRIER_REVIEW:
      color = 'ErGreen';
      break;
    case STAGE_V2.REINSTATEMENT_REVIEW:
      color = 'LgaBlue';
      break;
    case STAGE_V2.WAITING_FOR_APPROVAL:
      color = 'DarkBlue';
      break;
    case STAGE_V2.LEGAL_REVIEW:
      color = 'FeOlive';
      break;
    case STAGE_V2.POLICY_CLOSED:
      color = 'DarkGreen';
      break;
    case STAGE_V2.EVIDENCE_REVIEW:
      color = 'Yellow';
      break;
    case STAGE_V2.RESOLVED:
      color = 'MediumSeaGreen';
      break;
  }

  const label = applicationStages[stage]?.displayText || '';

  if (!label) return null;

  return <Tag color={color}>{label}</Tag>;
};
